import React, { FC, memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AssociationType } from 'api/gen/AssociationType';
import { MatingLoadingId } from 'app/mating/types';
import { MatingBullsFleckviehTable } from './mating-bulls-fleckvieh-table';
import { MatingBullsHolsteinTable } from './mating-bulls-holstein-table';
import { matingAction } from '../../model';
const MALE = 'MALE';
const HOLSTEIN = 'HOLSTEIN';
interface Props {
  /** Association type used to choose the table variant. */
  associationType: AssociationType;
  /** Loading flags that control table actions. */
  loading: Array<MatingLoadingId>;
}
const MatingBullsTableBase: FC<Props> = ({
  associationType,
  loading
}) => {
  const dispatch = useDispatch();
  const exportInProgress = loading.includes('exportInProgress');
  const removeBull = useCallback((id: number) => {
    dispatch(matingAction.removeAnimal(MALE, id, associationType));
  }, [associationType, dispatch]);
  const exportBullselectorResult = useCallback((): void => {
    dispatch(matingAction.exportMatingAnimals(MALE, associationType));
  }, [dispatch, associationType]);
  return associationType === HOLSTEIN ? <MatingBullsHolsteinTable removeBull={removeBull} exportBullselectorResult={exportBullselectorResult} exportInProgress={exportInProgress} data-sentry-element="MatingBullsHolsteinTable" data-sentry-component="MatingBullsTableBase" data-sentry-source-file="index.tsx" /> : <MatingBullsFleckviehTable removeBull={removeBull} exportBullselectorResult={exportBullselectorResult} exportInProgress={exportInProgress} data-sentry-element="MatingBullsFleckviehTable" data-sentry-component="MatingBullsTableBase" data-sentry-source-file="index.tsx" />;
};

/**
 * Memoized bulls table used by the mating workflow.
 *
 * @param props Association type and loading state for table actions.
 * @returns The bulls table.
 */
export const MatingBullsTable = memo(MatingBullsTableBase);